// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_HQy","rootNoMargin":"styles_rootNoMargin__qd0Yw"};